<!--
@name 硕士教育-人工智能应用与管理硕士
-->
<template>
  <div class="cont-page">
    <!-- 公共导航 -->
    <home-header></home-header>
    <!-- banner -->
    <div class="banner-info"></div>
    <!-- banner -->
    <!-- 内容 -->
    <div class="content">
      <!--  专业介绍 -->
      <div class="cont-item">
        <div class="title-image">专业介绍</div>
        <div class="selector-indent">
          人工智能正深刻重构全球商业生态，为企业创造效率跃升、流程革新与价值增长的全新机遇。在数字化竞争白热化的今天，人工智能应用与管理硕士专业应运而生。本专业深度融合管理学经典理论与前沿人工智能技术，致力于打造“懂技术、通业务、善决策”的复合型商业领袖，助力学生在人工智能的新商业时代中成为行业变革的引领者。本专业突破传统技术型AI培养框架，专注解决AI与业务场景的融合，将AI能力精准锚定商业目标，实现技术与战略的深度协同。
        </div>
      </div>
      <!--  专业介绍 -->
      <!--  项目优势 -->
      <div class="cont-item">
        <div class="title-image">项目优势</div>
        <div class="advantage">
          <p class="advantage-title">权威认证</p>
          <p>本项目已获得AACSB认证，全球前6%精英商学院之一，且学位获得中法两国认证。</p>
          <p class="advantage-title">实战融合</p>
          <p>通过制造业、金融业、零售业等跨行业AI解决方案深度剖析（含法国标杆案例)，培养场景化应用能力。</p>
          <p class="advantage-title">灵活学制</p>
          <p>本项目学制为18个月，在职学习，其中80%为线上课程，20%为线下实践，无需脱产学习。</p>
          <p class="advantage-title">双导师制</p>
          <p>教授、企业CTO\战略总监等携手从理论与实践层面深入指导。</p>
          <p class="advantage-title">前瞻能力矩阵培养</p>
          <p>构建AI项目管理、大模型本地化部署、智能体等新型能力项；开发《生成式商业创新》等前沿课程模块。</p>
          <p class="advantage-title">职业发展前景</p>
          <p>毕业生可在以下领域担任关键角色：</p>
          <p>- 智能化管理岗：数字化转型经理、AI产品运营官；</p>
          <p>- 技术咨询岗：商业智能分析师、AI解决方案架构师；</p>
          <p>- 创新研发岗：智能系统设计师、算法商业价值工程师；</p>
          <p>- 治理合规岗：AI伦理审计师、技术风险控制专家等。</p>
        </div>
      </div>
      <!-- 项目优势 -->
      <!-- 培养方式 -->
      <div class="cont-item">
        <div class="title-image">培养方式</div>
        <div class="selector-indent">
          法国布雷斯特高等商学院人工智能应用与管理硕士课程采用线上线下相结合的模式，致力于培养具备“AI思维”“商业洞察力”与“AI工具运用能力的核心管理者，以助力学员在数智化时代引领企业创新。
        </div>
      </div>
      <!-- 培养方式 -->
      <!-- 课程简介 -->
      <div class="cont-item">
        <div class="title-image">课程设置</div>
        <img src="@/assets/images/personRain/mba-ai-course.png" alt="" class="course-img"/>
      </div>
      <!-- 课程简介 -->
      <!-- 部分师资 -->
      <div class="cont-item">
        <div class="title-image">部分师资</div>
        <p>Luc Pontet：布雷斯特高等商学院副校长，布雷斯特工商会(Chambre de Commerce et d’ Industrie de Brest)信息技术及培训负责人。</p>
        <p>Mériadec Le Mouillour：海事功勋骑士勋章获得者/前西布列塔尼工商会总经理/法国港口联盟副主席、高级海事委员会成员和欧洲海港组织执行委员会成员。</p>
        <p>Bertrand PAUGET：布雷斯特高等商学院教授，研究专长涵盖组织创新、未来研究(foresight)、知识管理与健康系统转型现任教务长兼研究院院长。</p>
        <p>Dominique MAZÉ：布雷斯特高等商学院教授，国际战略与跨文化管理方向，EMBA项目主管。</p>
        <p>Houssem CHEMINGUI：布雷斯特高等商学院副教授，研究信息系统与数据工程方向，在人工智能与软件工程融合领域拥有前沿成果。</p>
        <p>姜正新：法国布雷斯特高等商学院荣誉校长，经济学博士，北京大学中国新兴产业创新研究中心专家委员会副主任，华中师范大学特骋教授。</p>
        <p>杜军：布雷斯特商学院高等商学院教授，北京大学客座教授，原日本NEC公司中国研究院院长、浙江北大信息技术高等研究院院长顾问。</p>
        <p>张智勇：北京大学心理学副教授，北京社会心理学会理事副秘书长，北京组织人事研究所助理研究员。</p>
        <p>张晨宇：北京理工大学，副教授，博士，硕士研究生导师，美国马凯特大学(Marquette University)商学院高级访问学者，从事创业投资、大学捐赠基金等方面的研究。</p>
        <p>刘刚：中国人民大学商学院教授，博士生导师，企业管理系主任。</p>
        <p>刘华鹏：北京中科汇联（准科创板）AI学院执行院长，国家工信部认证的人工智能应用高级工程师。</p>
        <p>赵永新：亚洲数字经济科学院中国区主任，全国优秀创新创业导师，清华大学，浙江大学，东北财经大学EDP特聘教授，中国技术经济学会金融科技专家，工信部区块链产业人才智库专家。</p>
      </div>
      <!-- 部分师资 -->
      <!-- 入学流程 -->
      <div class="cont-item">
        <div class="title-image">入学流程</div>
        <img src="@/assets/images/personRain/mba-lean-flow.png" alt="" class="flow-img"/>
        <!--申请条件-->
        <div class="title-image">申请条件</div>
        <p>本科或同等学历</p>
        <p>专科毕业，拥有3年及以上工作经验</p>
        <!--申请条件-->
        <!--申请材料-->
        <div class="title-image">申请材料</div>
        <div class="apply-item">
          <p class="apply-text">1.中英文申请表</p>
          <p class="apply-text">2.中英文简历</p>
          <p class="apply-text">3.中英文动机信</p>
          <p class="apply-text">4.毕业证复印件及英文翻译件或学信网认证报告及翻译件</p>
          <p class="apply-text">5.身份证原件照片复印件及英文翻译件</p>
          <p class="apply-text">6.白底两寸照片电子版</p>
          <p class="apply-text">7.中文推荐信1封</p>
        </div>
        <!--申请材料-->
      </div>
      <!-- 入学流程 -->
      <!-- 相关资料下载 -->
      <div class="down-load">
        <p>相关资料下载</p>
        <p class="open-pdf" @click="openPdf">人工智能应用与管理硕士</p>
      </div>
      <div style="clear: both"></div>
      <!-- 相关资料下载 -->
    </div>
    <!-- 内容 -->
    <!-- 公共版权 -->
    <home-footer></home-footer>
    <!-- 公共版权 -->

  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: 'EduMbaAi',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {
    openPdf() {
      window.open('http://cdn.yzvet.com/group1/M00/3F/F0/wKgCEmgF5OeAMAsHAkY79ClGvMY833.pdf', '_blank');
    }
  }
};
</script>

<style scoped lang="less">
.cont-page {
  background: #fff;
  height: auto;

  .banner-info {
    width: 100%;
    height: 200px;
    background: url(../assets/images/banner002.png);
    background-size: 100% 100%;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding-bottom: 80px;

    .cont-item {
      .title-image {
        background: url("../assets/images/pic1.png") no-repeat;
        width: 200px;
        height: 56px;
        line-height: 56px;
        background-size: 100% 100%;
        font-size: 24px;
        font-weight: 700;
        padding-left: 60px;
        color: #323232;
        margin: 40px 0;
      }

      p {
        font-size: 24px;
        color: #333;
        line-height: 38px;
      }

      .selector-indent {
        text-indent: 40px;
        font-size: 24px;
        font-weight: 400;
        color: #333;
        line-height: 38px;
      }

      //项目优势
      .advantage {
        .advantage-title {
          font-weight: bold;

          &:before {
            content: '';
            display: inline-block;
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background: #e58111;
            border-radius: 10%;
            margin-right: 8px;
          }
        }

        p {
          font-size: 24px;
          color: #333;
          vertical-align: middle;
        }
      }

      // 图片
      .course-img {
        max-width: 100%;
      }

      // 入学流程
      .flow-img {
        width: 100%;
      }

      // 申请资料
      .apply-item {
        background: #e58111;
        border-radius: 5px;
        margin-top: 20px;
        padding: 20px;

        .apply-text {
          color: #fff;
          font-size: 24px;
          line-height: 50px;
        }
      }
    }

    // 相关资料下载
    .down-load {
      float: right;
      font-size: 24px;
      margin-top: 50px;
      color: #333;
      text-align: right;

      .open-pdf {
        margin-top: 10px;
        font-size: 24px;
        color: #e58111;
        cursor: pointer;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/eduMbaAi.vue